import React from "react";
import heroImg from "../assets/quality-standards/Quality standard hero.png";
import qs3 from "../assets/quality-standards/qs3.webp";
import FaqSection from "../components/FaqSection";

const QualityStandards = () => {
  return (
    <div className="text-sm md:text-base lg:text-lg">
      {/* HERO SECTION */}
      <section className="relative w-full h-[70vh] md:h-[80vh] flex items-end text-white overflow-hidden">
        {/* Background image */}
        <img
          src={heroImg}
          alt="Hero background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* FULL OVERLAY tint instead of gradient */}
        <div
          className="absolute inset-0 z-10"
          style={{
            background:
              "linear-gradient(rgba(31, 41, 84, 0.5) 10%, rgba(239, 81, 75, 0.6) 77%)",
          }}
        />

        {/* Text content */}
        <div className="relative z-20 p-6 md:p-20">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Quality cars and service to match
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold">
            Each used car is thoroughly checked by highly trained technicians
            and our service standards are just as high with a customer service
            team that’s with you from A to B.
          </p>
        </div>
      </section>

      {/* Browse Buy and Relax */}
      <section className="bg-white py-10 px-4 rounded-tl-3xl relative">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 ">
          {/* Left: Image */}
          <div>
            <img
              //   src={qs1}
              src="https://images.unsplash.com/photo-1623682784866-6644395e42b4?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="What drives us"
              className="w-full h-full rounded-3xl object-cover"
            />
          </div>

          {/* Right: Text Content */}
          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
              Browse, buy and relax
            </h2>
            <p className="text-primary font-medium mb-4">
              All cars come with a minimum 6-month MOT, a free 90-day warranty,
              and a 14-day money back guarantee.
            </p>
            <p className="text-primary font-medium mb-4">
              We'll deliver it to your door or you can collect it yourself, and
              if you don't love it within 14 days, we'll pick it up for free.
              Easy.
            </p>
            <p className="text-primary font-medium mb-4">
              And ZORQK lets you protect what's important to you. It's your
              choice of extended warranty, tyre, scratch and dent, and alloy
              wheel insurance.
            </p>
            <p className="text-primary font-medium mb-4">
              It’s no wonder the nation is ZORQK it.
            </p>
          </div>
        </div>
      </section>

      {/* Comprehensive inspection for peace of mind */}
      <section className="bg-white pb-10 px-4 rounded-tl-3xl relative">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 ">
          {/* Left: Text */}
          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
              Comprehensive inspection for peace of mind
            </h2>
            <p className="text-primary font-medium mb-4">
              Every car must meet the high ZORQK standards before it goes on our
              site. It’s comprehensively inspected by trained technicians. And,
              if needed, the cars are repaired so they’re safe to drive,
              reliable and meet UK MOT standards.
            </p>
            <p className="text-primary font-medium mb-4">
              Every car is different, so we don’t set a minimum number of points
              to inspect, we tailor our checks to the car. You can be confident
              we know our EVs from our petrols.
            </p>
            <p className="text-primary font-medium mb-4">
              The details of what we inspect are explained below so you can
              absolutely ZORQK it with confidence and peace of mind.
            </p>
          </div>

          {/* Right: Image */}
          <div>
            <img
              //   src={qs2}
              src="https://plus.unsplash.com/premium_photo-1682142504172-1e43b41d8df2?q=80&w=1195&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="What drives us"
              className="w-full h-full rounded-3xl object-cover"
            />
          </div>
        </div>
      </section>

      {/* Check it out before you checkout */}
      <section className="bg-white py-10 px-4 rounded-tl-3xl relative">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 ">
          {/* Left: Image */}
          <div>
            <img
              src={qs3}
              alt="What drives us"
              className="w-full h-full rounded-3xl object-cover"
            />
          </div>

          {/* Right: Text Content */}
          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
              Check it out before you checkout
            </h2>
            <p className="text-primary font-medium mb-4">
              When you find a car you love, you’re seeing the car you get. Our
              virtual car walk around lets you get up close and personal,
              without having to get up off the couch.
            </p>
            <p className="text-primary font-medium mb-4">
              We use high-res imaging to capture every detail, inside and out,
              and we highlight any imperfections that are more than general wear
              and tear, so you know exactly what to expect.
            </p>
            <p className="text-primary font-medium mb-4">
              All our cars have been previously loved and lovingly inspected by
              us, but you should expect some general wear and tear that matches
              the age and mileage of the car you are buying.
            </p>
          </div>
        </div>
      </section>

      {/* What we fix */}
      <section className="max-w-6xl mx-auto text-primary pb-10 px-4">
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
          What we fix
        </h2>
        <p className="text-primary font-medium mb-4">
          If we find something that’s more than general wear & tear we fix it.
        </p>
        <p className="text-primary font-medium mb-4">
          Where an imperfection can be seen from two metres away, this will
          either be repaired or highlighted as an imperfection in the vehicle
          gallery.
        </p>
        <p className="text-primary font-medium mb-4">
          The inside gets the same care and attention.
        </p>
        <p className="text-primary font-medium mb-4">
          All traces of previous owner(s) are removed in the refurbishment
          process and all our cars get a full valet before delivery.
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-5 font-medium text-base">
          <li>
            There may be examples of general wear and tear, such as fading and
            light scuffs. Easily visible damage, such as significant rips,
            tears, holes, burns on the interior of the car will either be
            repaired or highlighted as an imperfection in the imperfection
            gallery{" "}
          </li>
          <li>
            Each car will be supplied with two functional keys unless
            highlighted as one key in the imperfection gallery
          </li>
          <li>
            Audio equipment will be working and models with ‘activated’ sat-nav
            will be good-to-go
          </li>
          <li>
            All safety-related items will be in full working order and
            damage-free
          </li>
        </ul>
      </section>

      {/* Total transparency */}
      <section className="bg-white pb-10 px-4 rounded-tl-3xl relative">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 ">
          {/* Left: Text */}
          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
              Total transparency
            </h2>
            <p className="text-primary font-medium mb-4">
              Any imperfections we can see, that fall outside of our standard,
              are highlighted on the car’s detail page.
            </p>
            <p className="text-primary font-medium mb-4">
              You can see any imperfections by clicking ‘Imperfections’ on the
              advert or clicking the imperfection circle on any of the full-car
              images.
            </p>
          </div>

          {/* Right: Image */}
          <div>
            <img
              //   src={qs4}
              src="https://plus.unsplash.com/premium_photo-1661434339467-9b717b43fc4c?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="What drives us"
              className="w-full h-full rounded-3xl object-cover"
            />
          </div>
        </div>
      </section>

      {/* Here to help you ZORQK it */}
      <section className="bg-white py-10 px-4 rounded-tl-3xl relative">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 ">
          {/* Left: Image */}
          <div>
            <img
              //   src={qs5}
              src="https://plus.unsplash.com/premium_photo-1661337109793-9e25fff1664a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODF8fGNhciUyMGRlbGl2ZXJ5JTIwc2VydmljZXxlbnwwfHwwfHx8MA%3D%3D"
              alt="What drives us"
              className="w-full h-full rounded-3xl object-cover"
            />
          </div>

          {/* Right: Text Content */}
          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
              Here to help you ZORQK it
            </h2>
            <p className="text-primary font-medium mb-4">
              The experts in our customer service team are there for you from A
              to B, even before you’re behind the wheel. And when you buy, it’s
              not bye-bye, you can still reach out for help after you’ve
              purchased.
            </p>
            <p className="text-primary font-medium mb-4">
              Call, email or WhatsApp if you need anything. For Sales enquiries,
              lines are open Monday–Saturday 8am–6pm and Sunday 10am-4pm. For
              aftersales enquiries, lines are open Monday–Saturday 8am–6pm.
            </p>
          </div>
        </div>
      </section>

      <FaqSection />
    </div>
  );
};

export default QualityStandards;
